import { versions } from './version';

export const environment = {
  production: false,
  ...versions
};
